import styled, { css } from 'styled-components'

import { color, space, SpaceProps, spacing, typography } from '../../../themes'
import type { MessageType } from './types'

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  margin-top: ${spacing(1)};
`

interface ContainerProps extends SpaceProps {
  type: MessageType
}

export const Container = styled.div<ContainerProps>`
  ${space};

  ${({ type }) =>
    type === 'error' &&
    css`
      color: ${color('red.01')};
    `}

  ${({ type }) =>
    type === 'caption' &&
    css`
      color: ${color('gray.02')};
    `}

  ${Row} {
    &:first-child {
      margin-top: 0;
    }
  }
`

export const IconWrapper = styled.span`
  margin-right: ${spacing(1.2)};
  margin-top: 3px;

  & > * {
    height: 20px;
    width: 20px;
  }
`

export const Message = styled.div`
  ${typography('body1')}
  word-break: break-all;
`
